export default __webpack_public_path__ + "5eb7a5ad7359ebe82489e6bb5edc4822.png";